var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{ref:"dialog",attrs:{"title":"新增商机","visible":_vm.addShow,"close-on-click-modal":false,"width":"750px"},on:{"update:visible":function($event){_vm.addShow=$event},"close":_vm.editorClose}},[_c('AddDealer',{ref:"addDealer",on:{"confirmSeasFun":_vm.onModalSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }